( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      const form = document.querySelector( '.shop-filter' );
      const formSubmit = form.querySelector( '.filter-submit' );

      form.querySelectorAll( 'input' ).forEach( ( input ) => {
        input.addEventListener( 'change', () => {
          if ( form.requestSubmit ) {
            form.requestSubmit();
          } else {
            formSubmit.click();
          }
        } );
      } );

      $( '.ll-woocommerce-ordering' ).on( 'change', 'select.orderby', function() {
        // console.log( $( this ).closest( 'form' ).find( 'button' )[0].click() );
        $( this ).closest( 'form' ).find( 'button' )[0].click();
      } );

      function updateShopSidebar( urlQuery ) {
        const links = document.querySelectorAll( 'a[data-meat]' );

        if ( urlQuery.has( 'page_term' ) ) {
          let term;
          let meat;
          if ( urlQuery.get( 'page_term' ) && urlQuery.get( 'page_tax' ) === 'product_cat' ) {
            term = urlQuery.get( 'page_term' );
            meat = document.querySelector( 'a[data-term="'+term+'"]' ).dataset.meat;
          }

          links.forEach( ( link ) => {
            const termQuery = urlQuery;
            if ( termQuery.has( 'cut[]' ) ) {
              if ( link.dataset.meat !== meat ) {
                termQuery.delete( 'cut[]' );
              }
            }

            termQuery.set( 'page_term', link.dataset.term );
            termQuery.set( 'page_tax', 'product_cat' );

            const currentUrl = new URL( link.href );
            currentUrl.search = '?'+decodeURIComponent( termQuery.toString() );
            link.href = currentUrl.toString();
          } );
        }
      }

      form.addEventListener( 'submit', ( e ) => {
        e.preventDefault();
        console.log( window.location.search );
        const formData = new FormData( e.target );
        const urlQuery = new URLSearchParams( formData );
        // if ( window.location.search ) {
        //   const orderbyQuery = new URLSearchParams( window.location.search );
        //   if ( orderbyQuery.get( 'orderby' ) ) {
        //     urlQuery.set( 'orderby', orderbyQuery.get( 'orderby' ) );
        //   } else {
        //     urlQuery.set( 'orderby', 'menu_order' );
        //   }
        // } else {
        //   urlQuery.set( 'orderby', 'menu_order' );
        // }

        history.replaceState( '', '', '?'+decodeURIComponent( urlQuery.toString() ) );
        filterShop( urlQuery.toString() );
        updateShopSidebar( urlQuery );
      } );

      const checkboxes = form.querySelectorAll( 'input[type="checkbox"]' );
      const oneChecked = Array.prototype.slice.call( checkboxes ).some( ( x ) => x.checked );

      if ( window.location.search ) {
        const urlQuery = new URLSearchParams( window.location.search );
        console.log( 'on load check' );
        console.log( urlQuery.toString() );
        filterShop( urlQuery.toString() );
        updateShopSidebar( urlQuery );
      } else if ( oneChecked ) {
        if ( form.requestSubmit ) {
          form.requestSubmit();
        } else {
          formSubmit.click();
        }
      }

      function filterShop( query ) {
        console.log( query );
        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'product/filter',
          data: query,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            document.querySelector( '.ll-shop__product-grid__wrapper .products' ).innerHTML = data;
          },
          error: function( error, status, thrown ) {
            console.log( error );
            console.log( status );
            console.log( thrown );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'shop-sidebar', COMPONENT );
} )( app );
